export const classes = {
  card: 'rounded-3xl border border-hair bg-panel px-8 py-6 shadow-aurora-card dark:border-hair-dark dark:bg-panel-dark dark:shadow-aurora-card-dark',
};
